import { createStyles, TextField, Theme, Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import AppContext from "../Context/Context";
import feedbackImg from "../assets/feedbackBird.png";
import thankYouImg from "../assets/thankYou.png";
import clsx from "clsx";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import ErrorIcon from "../assets/icons/ErrorIcon";
import BriaButton, { BUTTONTYPES } from "./UI/BriaButton";
import BriaLogo from "../assets/icons/BriaLogo";
import React from "react";
import { withStyles } from "@material-ui/styles";
import { getSendFeedbackEmail } from "../GraphQL/queries";
import Analytics, { ANALYTICS_EVENTS } from "../Models/Analytics";
import { IsGuestUser } from "../Helpers/isGuest";
import { LazyLoadImage } from "react-lazy-load-image-component";
interface IState {
	interests: Set<string>;
	feedbackSuccess: boolean;
	feedbackError: boolean;
	loading: boolean;
}

class FeedbackDialog extends React.Component<{}, IState> {
	state: IState = {
		interests: new Set<string>(),
		feedbackSuccess: false,
		feedbackError: false,
		loading: false,
	};

	render() {
		const { classes }: any = this.props;

		const submitFeedback = async (values: any, context: any) => {
			this.setState({
				loading: true,
			});
			let isSent = false;
			try {
				if (context.user) {
					const res = await getSendFeedbackEmail(
						values.feedbackText,
						context.user.uid,
						values.emailText
					);
					isSent = res.sendFeedbackEmail ?? false;
				}
			} catch (error: any) {}
			this.setState({
				feedbackSuccess: isSent,
				feedbackError: !isSent,
			});
			Analytics.logEvent(ANALYTICS_EVENTS.FEEDBACK_SUBMITTED, {
				succeeded: isSent,
			});
			this.setState({
				loading: false,
			});
		};

		const handleCloseFeedbackDialog = (context: any) => {
			context.setDisplayFeedbackDialogState(false);
			this.setState({
				feedbackSuccess: false,
				feedbackError: false,
			});
		};

		const initialValues = {
			feedbackText: "",
			emailText: "",
		};

		const feedbackSucceeded = () => (
			<Box>
				<Box>
					<img src={thankYouImg} className={classes.mainImg}></img>
				</Box>
				<Box className={classes.content}>
					<Typography
						className={clsx(
							classes.boldText,
							classes.fontColor,
							classes.title
						)}
					>
						Thank you!
					</Typography>
					<Typography
						className={clsx(classes.fontColor, classes.description)}
					>
						We will be in touch shortly.
					</Typography>
					<Box className={classes.logoContainer}>
						<BriaLogo className={classes.logo} />
					</Box>
				</Box>
			</Box>
		);
		return (
			<AppContext.Consumer>
				{(context) => {
					return (
						<Dialog
							onClose={() => handleCloseFeedbackDialog(context)}
							open={context.displayFeedbackDialog}
							maxWidth={false}
							classes={{
								paper: classes.dialog,
							}}
						>
							<Box>
								{this.state.feedbackSuccess ? (
									feedbackSucceeded()
								) : (
									<Box>
										<Box
											style={{
												minHeight: "235px",
												minWidth: "618px",
											}}
										>
											<LazyLoadImage
												className={classes.mainImg}
												effect="blur"
												threshold={100}
												useIntersectionObserver={false}
												src={feedbackImg}
												alt="Feedback Bird"
											/>
										</Box>
										<Box className={classes.content}>
											<Typography
												className={clsx(
													classes.boldText,
													classes.fontColor,
													classes.title
												)}
											>
												Share feedback
											</Typography>
											<Typography
												className={clsx(
													classes.fontColor,
													classes.description
												)}
											>
												We would love to hear your
												thoughts.
											</Typography>
											<Formik
												initialValues={initialValues}
												isInitialValid={false}
												validationSchema={Yup.object().shape(
													{
														feedbackText:
															Yup.string(),
														emailText: Yup.string(),
													}
												)}
												onSubmit={(values) =>
													submitFeedback(
														values,
														context
													)
												}
											>
												{({
													values,
													errors,
													handleChange,
													isValid,
												}) => (
													<Form
														className={
															classes.feedbackForm
														}
													>
														{IsGuestUser().isGuestUser() && (
															<TextField
																id="emailText"
																placeholder="Email"
																className={
																	classes.emailText
																}
																onChange={
																	handleChange
																}
																value={
																	values.emailText
																}
																fullWidth={true}
															/>
														)}
														<TextField
															id="feedbackText"
															placeholder="Enter your feedback"
															className={
																classes.feedbackText
															}
															multiline={true}
															rows={4}
															onChange={
																handleChange
															}
															value={
																values.feedbackText
															}
															error={
																!!errors.feedbackText
															}
															helperText={
																errors.feedbackText
															}
															fullWidth={true}
														/>

														{this.state
															.feedbackError && (
															<Typography
																className={
																	classes.error
																}
																color="secondary"
															>
																<ErrorIcon
																	className={
																		classes.errorIcon
																	}
																/>
																<span>
																	Ooops.
																	Please try
																	again later
																</span>
															</Typography>
														)}
														<Box
															className={
																classes.submitButton
															}
														>
															<BriaButton
																buttonType={
																	BUTTONTYPES.PRIMARY
																}
																type="submit"
																disabled={
																	this.state
																		.loading ||
																	!isValid
																}
															>
																Send
															</BriaButton>
														</Box>
													</Form>
												)}
											</Formik>
										</Box>
									</Box>
								)}
							</Box>
						</Dialog>
					);
				}}
			</AppContext.Consumer>
		);
	}
}

const styles = (theme: Theme) =>
	createStyles({
		dialog: {
			borderRadius: "10px !important",
			minWidth: "618px",
			minHeight: "618px",
		},
		mainImg: {
			marginTop: 60,
		},
		boldText: {
			fontWeight: 700,
		},
		content: {
			padding: "30px 30px  60px 30px",
		},
		fontColor: {
			color: "#495057",
		},
		description: {
			fontSize: 14,
			marginBottom: 30,
		},
		title: {
			fontSize: 24,
			marginBottom: 11,
		},
		error: {
			fontSize: 14,
			marginTop: 13,
			marginBottom: 2,
			"& span": {
				marginLeft: 5,
				color: "red",
			},
		},
		errorIcon: {
			fontSize: 14,
		},
		feedbackForm: {
			"& .MuiFormControl-root": {
				width: "100%",
			},
			"& .MuiFormHelperText-root.Mui-error": {
				color: "red",
			},
		},
		feedbackText: {
			"& textarea": {
				border: "1px solid black",
				paddingLeft: "0.5vw",
				paddingTop: 8,
			},
			"& .MuiInput-underline:before, .MuiInput-underline:after, .MuiInput-underline:hover":
				{
					borderBottom: "none !important",
				},
		},
		emailText: {
			"& input": {
				border: "1px solid black",
				paddingLeft: "0.5vw",
			},
			"& .MuiInput-underline:before, .MuiInput-underline:after, .MuiInput-underline:hover":
				{
					borderBottom: "none !important",
				},
		},
		submitButton: {
			marginTop: 30,
			width: "100%",
			textAlign: "right",
			"& button": {
				padding: "7px 35px",
			},
		},
		logo: {
			width: 102,
			height: "100%",
		},
		logoContainer: {
			width: "100%",
			textAlign: "right",
		},
	});

export default withStyles(styles)(FeedbackDialog);
